import { 
  Home, 
  FileText, 
  Image as ImageIcon, 
  CheckCircle, 
  DollarSign, 
  Calendar, 
  Package, 
  User,
  MessageSquare,
  Wifi,
  Car,
  UtensilsCrossed,
  Waves,
  Mountain,
  TreePine,
  Coffee,
  Tv,
  Wind
} from 'lucide-react';

export const STEPS = [
  { id: 1, title: 'Basic Info', icon: Home, description: 'Title, location, and dates' },
  { id: 2, title: 'Description', icon: FileText, description: 'Tell guests about your listing' },
  { id: 3, title: 'Photos', icon: ImageIcon, description: 'Add photos of your experience' },
  { id: 4, title: 'Amenities', icon: CheckCircle, description: 'What amenities are included' },
  { id: 5, title: 'Pricing', icon: DollarSign, description: 'Set your pricing structure' },
  { id: 6, title: 'Availability', icon: Calendar, description: 'Set availability and booking windows' },
  { id: 7, title: 'Packages', icon: Package, description: 'Create packages and accommodation options' },
  { id: 8, title: 'Instructor Info', icon: User, description: 'Add instructor or guide information' },
  { id: 9, title: 'Reviews', icon: MessageSquare, description: 'Import reviews from other platforms' },
  { id: 10, title: 'Review', icon: CheckCircle, description: 'Review and publish your listing' },
];

export const AMENITIES = [
  { id: 'wifi', label: 'WiFi', icon: Wifi },
  { id: 'parking', label: 'Free Parking', icon: Car },
  { id: 'kitchen', label: 'Kitchen', icon: UtensilsCrossed },
  { id: 'beach', label: 'Beach Access', icon: Waves },
  { id: 'mountain', label: 'Mountain View', icon: Mountain },
  { id: 'nature', label: 'Nature Access', icon: TreePine },
  { id: 'coffee', label: 'Coffee/Tea', icon: Coffee },
  { id: 'tv', label: 'TV/Entertainment', icon: Tv },
  { id: 'airConditioning', label: 'Air Conditioning', icon: Wind },
];

export const ROOM_AMENITIES = [
  { id: 'privateBath', label: 'Private Bathroom' },
  { id: 'ecoFriendly', label: 'Eco-Friendly Materials' },
  { id: 'heating', label: 'Heating' },
  { id: 'fan', label: 'Fan' },
  { id: 'balcony', label: 'Balcony/Patio' },
  { id: 'view', label: 'Scenic View' },
  { id: 'storage', label: 'Storage Space' },
];

export const DURATION_TYPES = [
  { id: 'fixed', label: 'Fixed Duration' },
  { id: 'range', label: 'Flexible Range' },
];

